<ng-container *ngIf="type === 'clientSide'">
  <nz-table #tableList [nzData]="tableData.data" [nzLoading]="loading" [nzTotal]="tableData.pagination.total"
  [nzFrontPagination]="true" [nzShowPagination]="showPagination" [nzPageSize]='tableData.pagination.pageSize'
  (nzPageIndexChange)="tableData.pagination.onPageChange($event)" [(nzPageIndex)]="tableData.pagination.pageIndex" nzShowQuickJumper>
    <thead (nzSortOrderChange)="tableData.sort($event)" nzSingleSort>
      <tr>
        <th nzWidth="50px" *ngIf="showCheckBox">
          <label nz-checkbox [(ngModel)]="tableData.checkBox.checkAll"
            (ngModelChange)="tableData.checkBox.selectAllCheckEvent()">
          </label>
        </th>
        <ng-container *ngFor="let item of tableData?.header">
          <th nzColumnKey={{item?.value}}  [nzShowSort]="item?.value?.length > 0" [nzFilterMultiple]="false">
            {{ item?.key | translate }}
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of tableList.data;">
        <td *ngIf="showCheckBox">
          <label nz-checkbox [(ngModel)]="data.checked"
            (ngModelChange)="tableData.checkBox.selectSingleCheckEvent(data.index)"></label>
        </td>
        <td *ngFor="let key of tableData?.dataKeys"  class="columnwidth"  title="{{data[key]}}">
          <span *ngIf="key === 'serialNo'">{{ data[key] || data.index + 1 }}</span>
          <span *ngIf="key !== 'serialNo'">{{ data[key] }}</span>
        </td>
        <td *ngIf="tableData.actions">
          <a nz-button nz-dropdown [nzDropdownMenu]="menu">
            <i nz-icon nzType="more"></i></a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li nz-menu-item *ngFor="let action of tableData?.actions">
                <a *ngIf="!action.showConfirmOption" id="{{ action.actionName }}"
                  (click)="action.actionEvent(data.index)">
                  <i nz-icon nzTheme="outline" nzType="{{ action.actionType }}"></i>
                  {{ action.actionLabel | translate }}</a>
                <a id="{{ action.actionName }}" *ngIf="action.showConfirmOption" nz-popconfirm
                  nzPopconfirmTitle="Are you sure?" nzOkText="ok" nzCancelText="cancel"
                  (nzOnConfirm)="action.actionEvent(data.index)">
                  <i nz-icon nzTheme="outline" nzType="{{ action.actionType }}"></i>
                  {{ action.actionLabel | translate }}</a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-container>

<ng-container *ngIf="type === 'serverSide'">
  <nz-table [nzData]="tableData.data"  [nzLoading]="loading" [nzTotal]="tableData.pagination.total"
  [nzFrontPagination]="false" [nzShowPagination]="showPagination" [nzPageSize]='tableData.pagination.pageSize'
  (nzPageIndexChange)="tableData.pagination?.onPageChange($event)" [(nzPageIndex)]="tableData.pagination.pageIndex">
    <thead (nzSortOrderChange)="tableData.sort($event)" nzSingleSort>
      <tr>
        <th nzWidth="50px" *ngIf="showCheckBox">
          <label nz-checkbox [(ngModel)]="tableData.checkBox.checkAll"
            (ngModelChange)="tableData.checkBox.selectAllCheckEvent()">
          </label>
        </th>
        <ng-container *ngFor="let item of tableData?.header">
          <th [nzSortFn]="item?.value?.length > 0 ? true:false" nzColumnKey={{item?.value}} [nzShowSort]="item?.value?.length > 0" [nzFilterMultiple]="false">
            {{ item?.key | translate }}
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of tableData?.data; let i = index">
        <td *ngIf="showCheckBox">
          <label nz-checkbox [(ngModel)]="data.checked"
            (ngModelChange)="tableData?.checkBox?.selectSingleCheckEvent(i)"></label>
        </td>
        <td *ngFor="let key of tableData?.dataKeys"  class="columnwidth"  title="{{data[key]}}">
          <ng-container *ngIf="!getCustomizeCol(key); else others ">
            {{ data[key] }}
          </ng-container>
          <ng-template #others>
            <ng-container [ngSwitch]="getCustomizeCol(key)?.colType">
              <ng-container *ngSwitchCase="'a'">
                <a [ngClass]="getCustomizeCol(key)?.a?.css" (click)="getCustomizeCol(key)?.a?.eventHandler(i)"> {{ data[key] }}</a>
              </ng-container>
              <ng-container *ngSwitchCase="'tag'">
                <nz-tag [nzColor]="getCustomizeCol(key)?.tag?.cssHandler(i)" (click)="getCustomizeCol(key)?.tag?.eventHandler(i)">
                  {{ data[key] }}
                </nz-tag>
              </ng-container>
              <ng-container *ngSwitchCase="'icon'">
                <ng-container *ngIf="this.getCustomizeCol(key)?.icon?.mutilineToolTip else singleLine">
                 <i nz-tooltip [nzTooltipTitle]="multiLineTemplate" *ngIf="showHide(data, key)" nz-icon [nzType]="getIcon(i,key)" [nzTheme]="getCustomizeCol(key)?.icon?.nzTheme"
                 [ngClass]="getCustomizeCol(key)?.icon?.css" (click)="getCustomizeCol(key)?.icon?.eventHandler(i)"></i>
                 <ng-container *ngIf="getCustomizeCol(key)?.icon?.showWithText">
                   {{ data[key] }}
                 </ng-container>
                </ng-container>
                <ng-template #singleLine>
                 <i nz-tooltip [nzTooltipTitle]="getToolTipTitle(data, key)" *ngIf="showHide(data, key)" nz-icon [nzType]="getIcon(i,key)" [nzTheme]="getCustomizeCol(key)?.icon?.nzTheme"
                 [ngClass]="getCustomizeCol(key)?.icon?.css" (click)="getCustomizeCol(key)?.icon?.eventHandler(i)"></i>
                 <ng-container *ngIf="getCustomizeCol(key)?.icon?.showWithText">
                   {{ data[key] }}
                 </ng-container>
                </ng-template>
                <ng-template #multiLineTemplate >
                  <div *ngFor="let line of data[this.getCustomizeCol(key)?.icon?.toolTipKey]">
                    <span>{{line}}</span>
                  </div>
                </ng-template>
             </ng-container>
            <ng-container *ngSwitchCase="'multipleIcons'">
              <ng-container *ngIf="this.getCustomizeCol(key)?.multipleIcons">
                <span *ngFor="let selectedIon of this.getCustomizeCol(key)?.multipleIcons">
                  <a style="margin-left: 10px;" (click)="selectedIon.eventHandler(i)">
                    <i nz-tooltip [nzTooltipTitle]="selectedIon?.toolTipKey" nz-icon [nzType]="selectedIon?.nzType"
                      nzTheme="outline" [ngClass]="selectedIon?.css" (click)="selectedIon?.eventHandler(i)"></i>
                  </a>
                </span>
              </ng-container>
            </ng-container>
              <ng-container *ngSwitchCase="'innerHTML'">
                <div [innerHtml]="appendHtml(getCustomizeCol(key)?.innerHTML?.content)" ></div>
              </ng-container>
            </ng-container>
          </ng-template>
        </td>
        <td *ngIf="tableData.actions">
          <a nz-button nz-dropdown [nzDropdownMenu]="menu">
            <i nz-icon nzType="more"></i></a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <ng-container *ngFor="let action of tableData?.actions">
                <li nz-menu-item *ngIf="action?.showHide ? action?.showHide?.option === 'hide' ? data[action?.showHide?.key] !== action?.showHide?.value : data[action?.showHide?.key] === action?.showHide?.value : true">
                  <a id="{{ action.actionName }}" *ngIf="!action.showConfirmOption" (click)="action.actionEvent(i)">
                    <i nz-icon nzTheme="outline" nzType="{{ action.actionType }}"></i>
                    {{ action.actionLabel | translate }}</a>
                  <a id="{{ action.actionName }}" *ngIf="action.showConfirmOption" nz-popconfirm
                    nzPopconfirmTitle="Are you sure?" nzOkText="ok" nzCancelText="cancel"
                    (nzOnConfirm)="action.actionEvent(i)">
                    <i nz-icon nzTheme="outline" nzType="{{ action.actionType }}"></i>
                    {{ action.actionLabel | translate }}</a>
                </li>
              </ng-container>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-container>
